export default [
	{
		path: '/message/list/:patientId',
		name: 'messageList',
		component: () => import('@/views/message/list.vue'),
		meta: { title: '医生消息' }
	},
	{
		path: '/message/detail/:id',
		name: 'messageDetail',
		component: () => import('@/views/message/detail.vue'),
		meta: { title: '消息详情' }
	}
]
